import _classCallCheck from "/codebuild/output/src2759447873/src/landings/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src2759447873/src/landings/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var DecodedParamCache = /*#__PURE__*/function () {
  function DecodedParamCache() {
    _classCallCheck(this, DecodedParamCache);
    this.paramsMap = /* @__PURE__ */new Map();
    this.registeredParams = /* @__PURE__ */new Map();
  }
  _createClass(DecodedParamCache, [{
    key: "set",
    value: function set(param, stringifiedValue, decodedValue, decode) {
      this.paramsMap.set(param, {
        stringified: stringifiedValue,
        decoded: decodedValue,
        decode: decode
      });
    }
  }, {
    key: "has",
    value: function has(param, stringifiedValue, decode) {
      if (!this.paramsMap.has(param)) return false;
      var cachedParam = this.paramsMap.get(param);
      if (!cachedParam) return false;
      return cachedParam.stringified === stringifiedValue && (decode == null || cachedParam.decode === decode);
    }
  }, {
    key: "get",
    value: function get(param) {
      var _a;
      if (this.paramsMap.has(param)) return (_a = this.paramsMap.get(param)) == null ? void 0 : _a.decoded;
      return void 0;
    }
  }, {
    key: "registerParams",
    value: function registerParams(paramNames) {
      var _iterator = _createForOfIteratorHelper(paramNames),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var param = _step.value;
          var currValue = this.registeredParams.get(param) || 0;
          this.registeredParams.set(param, currValue + 1);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "unregisterParams",
    value: function unregisterParams(paramNames) {
      var _iterator2 = _createForOfIteratorHelper(paramNames),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var param = _step2.value;
          var value = (this.registeredParams.get(param) || 0) - 1;
          if (value <= 0) {
            this.registeredParams.delete(param);
            if (this.paramsMap.has(param)) {
              this.paramsMap.delete(param);
            }
          } else {
            this.registeredParams.set(param, value);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.paramsMap.clear();
      this.registeredParams.clear();
    }
  }]);
  return DecodedParamCache;
}();
var decodedParamCache = new DecodedParamCache();
export { DecodedParamCache, decodedParamCache };